import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL
  || (process.env.NODE_ENV === 'production' ? 'https://api.golaunchnow.io' : '');

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('signal_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('signal_token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const auth = {
  signup:        (data)            => api.post('/api/auth/signup', data),
  login:         (data)            => api.post('/api/auth/login', data),
  me:            ()                => api.get('/api/auth/me'),
  invite:        (email)           => api.post('/api/auth/invite', { email }),
  connections:   ()                => api.get('/api/auth/connections'),
  disconnect:    (platform, accountId) => api.delete(accountId
                   ? `/api/auth/disconnect/${platform}/${accountId}`
                   : `/api/auth/disconnect/${platform}`),
  forgotPassword: (email)          => api.post('/api/auth/forgot-password', { email }),
  resetPassword:  (token, password)=> api.post('/api/auth/reset-password', { token, password }),
  startOAuth:      (platform)       => api.post(`/api/auth/oauth/${platform}/start`),
};

export const dashboard = {
  overview:       (range) => api.get('/api/dashboard/overview',        { params: range }),
  topPosts:       (params) => api.get('/api/dashboard/top-posts',      { params }),
  insights:       (params) => api.get('/api/dashboard/insights',       { params }),
  trends:         (range) => api.get('/api/dashboard/trends',          { params: range }),
  platformTrends: (range) => api.get('/api/dashboard/platform-trends', { params: range }),
  platforms:      (range) => api.get('/api/dashboard/platforms',       { params: range }),
  settings:       () => api.get('/api/dashboard/settings'),
  updateSettings: (data) => api.patch('/api/dashboard/settings', data),
  sync:           () => api.post('/api/dashboard/sync'),
};

export default api;
